import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { appActions } from '../appSlice'
import { TAB_TYPE_SEPARATOR } from '../../../features/botHeaderTabs'
import { BotHeaderTabType } from '../../../features/botHeaderTabs/types'

export const useTabFromUrl = () => {
  const dispatch = useDispatch()
  const { search } = useLocation()
  const tabFromUrl = useMemo(() => getTabFromSearch(search), [search])

  useEffect(() => {
    const { NlpTraining, NlpChatQueries } = BotHeaderTabType
    const [type, ...tabIdParts] = tabFromUrl?.split(TAB_TYPE_SEPARATOR) || []

    if (!type) return
    if ([NlpTraining, NlpChatQueries].includes(type as BotHeaderTabType)) {
      dispatch(appActions.selectTab({ tab: { type: type as BotHeaderTabType } }))
      return
    }

    const tabId = tabIdParts.join(TAB_TYPE_SEPARATOR)
    dispatch(appActions.selectTab({ tab: { type: type as BotHeaderTabType, id: tabId } }))
  }, [dispatch, tabFromUrl])

  return tabFromUrl
}

const getTabFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search)
  return params.get('tab')
}
